// award-badges.js - Insert badges inside image container link

(function() {
  'use strict';
  
  let hasRun = false;
  let observer;
  
  const getShortProductId = (gid) => String(gid).replace("gid://shopify/Product/", "");
  
  // apply award badges
  async function applyAwardBadges() {
    if (hasRun) return;
    
    const cards = document.querySelectorAll(".blm-product-search__result");
    if (!cards.length) return;
    
    hasRun = true;
    if (observer) observer.disconnect();
    
    // Extract product IDs
    const productIds = Array.from(cards)
      .map(card => card.querySelector("product-badge")?.dataset.productId)
      .filter(Boolean);
    
    if (!productIds.length) return;
    
    // Fetch and apply badges
    const awardData = await fetchAwardBadges(productIds);
    cards.forEach(card => {
      const productId = card.querySelector("product-badge")?.dataset.productId;
      if (productId && awardData[productId]?.length) {
        renderAwardBadges(card, awardData[productId]);
      }
    });
  }
  
  // Fetch award badge data from Shopify
  async function fetchAwardBadges(productIds) {
    const fullGids = productIds.map(id => `gid://shopify/Product/${id}`);
    
    const query = `
      query getAwardBadges($ids: [ID!]!) {
        nodes(ids: $ids) {
          ... on Product {
            id
            metafield(namespace: "custom", key: "award_image_reference") {
              references(first: 10) {
                edges {
                  node {
                    ... on Metaobject {
                      fields {
                        key
                        reference {
                          ... on MediaImage {
                            image {
                              url
                              altText
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    `;
    
    try {
      const response = await fetch(`https://${window.Shopify.shop}/api/2025-01/graphql.json`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": "fa461acd789eda3169914d681fe74ba9"
        },
        body: JSON.stringify({ query, variables: { ids: fullGids } })
      });
      
      const json = await response.json();
      const result = {};
      
      if (json.data?.nodes) {
        json.data.nodes.forEach(node => {
          const productId = getShortProductId(node.id);
          const awards = [];
          
          const refs = node.metafield?.references?.edges || [];
          refs.forEach(edge => {
            const imageField = edge.node.fields.find(field => field.key === "image");
            if (imageField?.reference?.image) {
              awards.push(imageField.reference.image);
            }
          });
          
          result[productId] = awards;
        });
      }
      
      return result;
    } catch (error) {
      console.error("Error fetching award badges:", error);
      return {};
    }
  }
  
  // Render award images in DOM
  function renderAwardBadges(card, images) {

    const existing = card.querySelector(".award-images");
    if (existing) existing.remove();
    
    const container = document.createElement("div");
    container.className = "award-images";
    container.style.cssText = "margin: 5px 0; display: flex; gap: 5px; flex-wrap: wrap;";
    
    // Add images
    images.forEach(img => {
      const el = document.createElement("img");
      el.src = img.url;
      el.alt = img.altText || "Award badge";
      el.loading = "lazy";
      el.width = 90;
      el.height = 59;
      container.appendChild(el);
    });
    
    const imageLink = card.querySelector(".blm-product-search-image-container a");
    if (imageLink) {
      imageLink.appendChild(container);
    }
  }
  
  // Set up observer for dynamic content
  function setupObserver() {
    observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) {
            if (node.classList?.contains('blm-product-search__result')) {
              setTimeout(applyAwardBadges, 500);
            }
            const cards = node.querySelectorAll?.('.blm-product-search__result');
            if (cards?.length) {
              setTimeout(applyAwardBadges, 500);
            }
          }
        });
      });
    });
    
    observer.observe(document.body, { childList: true, subtree: true });
  }
  
  // Event listeners
  document.addEventListener("DOMContentLoaded", () => {
    setupObserver();
    setTimeout(applyAwardBadges, 2000);
  });
  
  document.addEventListener("bloomreach:searchResults:updated", () => {
    setTimeout(applyAwardBadges, 500);
  });
  
  document.addEventListener("carousel:updated", () => {
    setTimeout(applyAwardBadges, 500);
  });
  
  // Immediate execution if DOM already loaded
  if (document.readyState !== "loading") {
    setupObserver();
    setTimeout(applyAwardBadges, 2000);
  }
})();
